<!-- <nb-card>
  <nb-tabset fullWidth>
      <nb-tab [tabTitle]="item.title" *ngFor="let item of value">
        <div class="col-12">
          <br>
          <ngx-form-list-contact-entry [(item)]="item"></ngx-form-list-contact-entry>
        </div>

      </nb-tab>
      <nb-tab tabTitle="+">

        <div class="col-12">
          <br>
            <ngx-form-dropdown title="Type" [(value)]="newContact.type" displayField="value" keyField="key" [options]="contactTypes | enumKeys" (valueChange)="onTypeChange($event)"></ngx-form-dropdown>
            <ngx-form-text title="Contact Name" [(value)]="newContact.title"></ngx-form-text>
            <ngx-form-text *ngIf="showAddressName" title="Address Name" [(value)]="newContact.addressName"></ngx-form-text>
            <button class="btn btn-primary pull-right" (click)="addContact()" 
              [disabled]="!newContact.title || !newContact.type || (showAddressName && !newContact.addressName)">Add</button>
        </div>

      </nb-tab>
  </nb-tabset>
  <br>
</nb-card> -->

<div class="contacts">
  <table>
    <tr>
      <th *ngFor="let type of contactTypes | enumKeys">{{type.value}}</th>
    </tr>
    <tr>
      <td *ngFor="let type of contactTypes | enumKeys">
        <ul *ngIf="options[type.key]?.length == 1">
          <ng-container *ngFor="let item of value">
            <li *ngIf="item.type == type.key" [ngClass]="{'contact-selected': selected === item}" (click)="selected = item">
              <div >{{item.title}}</div>
            </li>
          </ng-container>
        </ul>
        <ngx-doc-form-filter-select *ngIf="options && options[type.key]?.length > 1" [options]="options[type.key]" (valueChange)="select($event)"></ngx-doc-form-filter-select>
      </td>
    </tr>
  </table>
  <button style="margin-left:3em" class="nrk-button" (click)="this.selected = null">add contact</button>
  <div class="contact-item">
    <div *ngIf="!selected" class="col-12">
        <ngx-form-dropdown title="Type" [(value)]="newContact.type" displayField="value" keyField="key" [options]="contactTypes | enumKeys" (valueChange)="onTypeChange($event)"></ngx-form-dropdown>
        <ngx-form-text [title]="newContact.type == contactTypes.General ? 'Address Name' : 'Contact Name'" [(value)]="newContact.title"></ngx-form-text>
        <ngx-form-text *ngIf="showAddressName" title="Address Name" [(value)]="newContact.addressName"></ngx-form-text>
        <button class="btn btn-primary pull-right" (click)="addContact()" 
          [disabled]="!newContact.title || !newContact.type || (showAddressName && !newContact.addressName)">Add</button>
        <br>
        <br>
    </div>
    <ngx-form-list-contact-entry *ngIf="selected" [(item)]="selected" [items]="value" [newItemOnTypeChange]="false"></ngx-form-list-contact-entry>
  </div>
</div>
